import i18n from '@/plugins/i18n'

export default {
  data () {
    return {
      dialogOptions: {
        okText: i18n.t('common.ok'),
        cancelText: i18n.t('common.back'),
        animation: 'bounce',
        backdropClose: false
      }
    }
  }
}
